(ns client-portal.client.reports.list.views
  (:require [client-portal.client.layout :as l]
            [client-portal.client.reports.individual.data]
            [client-portal.client.reports.list.data]
            [client-portal.client.voice-insights.empty-state :as empty-state]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.time :as t]))

(defn reports-list []
  (let [reports- (re/subscribe [:reports/list-data-flattened-])
        loading?- (re/subscribe [:reports/list-loading?-])
        has-more?- (re/subscribe [:reports/list-data-has-more?-])
        next-page-loading?- (re/subscribe [:reports/list-next-page-loading?-])
        next-page- (re/subscribe [:reports/list-next-page-])
        admin?- (re/subscribe [:account/admin-role?-])
        creating-edit-session?- (re/subscribe [:reports/creating-edit-session?-])]
    (fn []
      [alc/table {:no-data-text "No reports to display"
                  :loading-more? @next-page-loading?-
                  :loading? @loading?-
                  :scroll-container-id l/core-scroll-content-id
                  :bottom-px-buffer 200
                  :on-bottom-buffer (when @has-more?-
                                      #(re/dispatch [:reports/load-list [nil {:page @next-page-}]]))
                  :has-more-rows? true
                  :sticky-headers? true
                  :header-top 60
                  :no-data-material-icon :inventory_2
                  :no-data-style empty-state/base-container-style
                  :row-style {:height :auto
                              :align-items :flex-start}
                  :flex-vals ["2 1 200px" "3 1 300px" "0 0 220px" "0 0 160px"]
                  :headers ["Title"
                            "Description"
                            "Owner"
                            "Last Modified"]
                  :rows (mapv (fn [{:keys [public-id title description owner-email-address is-owner last-modified-at]}]
                                {:cells [{:label title
                                          :style {:color (style/alc-color "Text/primary")
                                                  :font-weight 500}}
                                         {:label (when-not (empty? description) description)
                                          :style {:color (style/alc-color "Text/secondary")}}
                                         {:label (if is-owner "Me" owner-email-address)
                                          :style {:color (style/alc-color "Text/secondary")}}
                                         {:label (some-> last-modified-at
                                                         (t/utc->local)
                                                         (t/as-format "MMM d, y h:mm A"))
                                          :style {:color (style/alc-color "Text/secondary")
                                                  :white-space :nowrap}}]
                                 :actions (when @admin?-
                                            [{:icon-type :edit
                                              :disabled? @creating-edit-session?-
                                              :on-click #(re/dispatch [:reports/edit-report public-id])
                                              :tooltip-content "Edit Report"}])
                                 :on-click #(re/dispatch [:reports/open-report public-id])})
                              @reports-)}])))

(defn root [_]
  (let [reports- (re/subscribe [:reports/list-data-flattened-])
        loading?- (re/subscribe [:reports/list-loading?-])]
    (re/create-class
      {:component-did-mount
       #(re/dispatch [:reports/initialize])

       :reagent-render
       (fn [args]
         (let [reports @reports-
               loading? @loading?-]
           [l/logged-in-with-header-nav-vi
            args
            [l/standard-content-container {:title "Reports"
                                           :sticky-header? true}
             (cond
               (or loading? (nil? reports)) [empty-state/loading-reports-card]
               (empty? reports) [empty-state/no-data-card
                                 {:text "No reports to display"
                                  :material-icon-type :inventory_2}]
               :else [reports-list])]]))})))
